__turbopack_context__.v({
  "content": "_9XHizW_content",
  "loadingCard": "_9XHizW_loadingCard",
  "wrapper": "_9XHizW_wrapper",
});
